module.exports = __webpack_public_path__ + "static/img/AbInbev.ec34a577.png";